import React from "react";
import partners from "../../images/home/partners.png";

const Partners = React.memo(() => {
  return (
    <div className="home-partners">
      <h1>Global reach and Partnerships</h1>
      <div className="home-partners-images">
        {Array.from({ length: 8 }).map((_, i) => (
          <img key={i} src={partners} alt="partners" />
        ))}
      </div>
      <canvas className="shape1" />
      <canvas className="shape2" />
    </div>
  );
});

export default Partners;
